import ReactGA from "react-ga4";

// Initialize Google Analytics with your tracking ID
ReactGA.initialize("G-Z1P5Y89ZH8"); 
ReactGA.send({ 
  hitType: "pageview",
  page: window.location.pathname + window.location.search
}); // Track page views with more detailed info

import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import HowItWorks from "./pages/HowItWorks";
import CallToAction from "./pages/CallToAction";
import NoMoreBoostCards from "./pages/NoMoreBoostCards";
import BoostCardsOnTheWay from "./pages/BoostCardsOnTheWay";
import AvailableEateries from "./pages/AvailableEateries";
import ArrivingSoon from "./pages/ArrivingSoon";
import Support from "./pages/Support";
import Close from "./pages/Close";
import Testimonials from "./pages/Testimonials";
import Mission from "./pages/Mission";

// Scroll to top component - Enhanced with Analytics tracking
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track page view on route change
    ReactGA.send({
      hitType: "pageview",
      page: pathname
    });
  }, [pathname]);

  return null;
};

const queryClient = new QueryClient();

const App = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/mission" element={<Mission />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/download" element={<CallToAction />} />
            <Route path="/no-more-boost-cards" element={<NoMoreBoostCards />} />
            <Route path="/boost-cards-on-the-way" element={<BoostCardsOnTheWay />} />
            <Route path="/available-eateries" element={<AvailableEateries />} />
            <Route path="/arriving-soon" element={<ArrivingSoon />} />
            <Route path="/support" element={<Support />} />
            <Route path="/close" element={<Close />} />
            <Route path="/testimonials" element={<Testimonials />} />
          </Routes>
          <Toaster />
          <Sonner />
        </TooltipProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
